





























































import { Component, Vue, Prop, Watch, InjectReactive } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { queryUsers } from '../services/graph/user.graph';
import avatar_initials from '../utils/avatar-initials';
import { User } from '../interfaces/models/user';
const slides = namespace('slides');

@Component({
  filters: {
    avatar(input: string) {
      return avatar_initials(input);
    }
  }
})
export default class AssignmentBoundary extends Vue {
  private searchIcon = 'mdi-account-search';
  private isLoading = false;
  private open = false;

  @Prop({ type: String, required: true }) assetId!: string;
  @Prop({ type: Array }) assignments?: User.BaseInfos[] = [];

  @slides.Action('assignUser') assign!: (payload: { userId: string; slideId: string }) => void;
  @slides.Action('deassignUser') deassign!: (payload: { userId: string; slideId: string }) => void;

  searchQuery = '';
  users: User.BaseInfos[] = [];
  assignedUser = this.assignments;

  get hasNoAssignment() {
    return this.assignedUser && this.assignedUser.length === 0;
  }

  isAssigned(id: string) {
    return this.assignedUser && this.assignedUser.filter(y => y._id === id).length > 0;
  }

  @Watch('assignments')
  onChange(newUsers: { _id: string; email: string; name: string }[]) {
    this.assignedUser = newUsers;
  }

  @Watch('searchQuery')
  async onSearchQueryChange(e: string) {
    if (e === '') return;
    this.isLoading = true;
    try {
      const users = await queryUsers(e);
      this.users = users;
    } catch (error) {
      console.log('query users', error);
    } finally {
      this.isLoading = false;
    }
  }

  async deassignAll() {
    if (!this.assignedUser || !this.assetId) return;
    return await Promise.all(
      this.assignedUser.map(async (user: User.BaseInfos) => {
        return await this.deassign({ userId: user._id, slideId: this.assetId });
      })
    );
  }

  async handleAssign(user: User.BaseInfos) {
    try {
      if (this.assignedUser && this.assignedUser.length > 0) {
        // deassign all then assign new
        await this.deassignAll();
      }

      await this.assign({ userId: user._id, slideId: this.assetId });
      this.assignedUser = [user];
      this.$emit('reload');
      this.open = false;
    } catch (error) {
      console.log('assign', error);
    }
  }

  async handleDeassign() {
    try {
      await this.deassignAll();
      this.assignedUser = [];
      this.$emit('reload');
    } catch (error) {
      console.log('deassign', error);
    }
  }
}
